"use client"; // Error components must be Client Components

import { useEffect } from "react";
import { PageError } from "@yardzen/ui/components/page-error";

export interface ErrorPageProps {
  error: Error;
  reset: () => void;
}

export function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <PageError
      title="We're sorry, but something went wrong."
      description="Please try again or contact us for assistance."
      displayContactInfo={true}
      allowRefreshButton={true}
    />
  );
}
